import { render } from "./FreezeButton.vue?vue&type=template&id=646f9ae2"
import script from "./FreezeButton.vue?vue&type=script&lang=js"
export * from "./FreezeButton.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1189531127/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__